import {
  apiContactFormSubmitFailed,
  apiContactFormSubmitRequested,
  apiContactFormSubmitSucceeded
} from '../../../api/contact/submitContactFormApi';
import { call, put } from 'typed-redux-saga';
import submitContactFormAction, {
  SubmitContactFormActionInput
} from '@spa/lib/actions/contact/submitContactFormAction';
import { PayloadAction } from '@reduxjs/toolkit';
import { SubmitContactFormResult } from '@spa/lib/graphql/transactional-email/submitContactForm';

function* submitContactFormApiSaga(
  action: PayloadAction<ReturnType<typeof apiContactFormSubmitRequested>['payload']>
): Generator {
  try {
    const input: SubmitContactFormActionInput = {
      formData: action.payload.formData,
      honeypotToken: action.payload.honeypotToken
    };
    const result: SubmitContactFormResult = yield* call(
      submitContactFormAction,
      'submitContactFormAction',
      input
    );

    yield* put(
      apiContactFormSubmitSucceeded({
        requestedActionId: action.payload.actionId,
        result
      })
    );
  } catch (error) {
    yield* put(
      apiContactFormSubmitFailed({
        requestedActionId: action.payload.actionId,
        error: error as Error
      })
    );
  }
}

export default submitContactFormApiSaga;
